module.exports = __webpack_public_path__ + "static/media/person-carry.b89aebbe.svg";